<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Contemporary Music
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p><strong>Contemporary Music</strong> recorded close to $1.8b in revenue and more than 13.7m attendances in 2025. These results are the second-highest recorded for this category (with 2024 being the highest). These results are attributable to a full year of major international tours, including Lady Gaga, Oasis, AC/DC, Luke Combs, Drake, Tyler: The Creator, Billie Eilish, Metallica and Kendrick Lamar.</p>
          <p><strong>Contemporary Music</strong> accounted for the largest market share in both revenue (53.5%) and attendance (44.8%) within the live performance industry in 2025.</p>
          <p><strong>Contemporary Music</strong> recorded a slight y-o-y decline in revenue of 0.9% (from $1.81b in 2024 to $1.79b in 2025) and a y-o-y decline in attendance of 2.4% (from 14.1m in 2024 to 13.7m in 2025).</p>
          <p>The average ticket price increased by 2.0% y-o-y (from $135.39 in 2024 to $138.15 in 2025), which partially offset the decline in revenue.</p>
        </div>
        <div class="sixcol last">
          <p>In 2025, NSW and VIC generated the most revenue and attendance in this category. These two states generated 69.8% of overall revenue and 66.7% of overall attendance in this category in 2025. Some international acts only toured to NSW and VIC, which may explain the market share results.</p>
          <p>In 2025, NSW, VIC and TAS recorded y-o-y declines in both revenue and attendance. QLD recorded y-o-y growth in revenue despite a decline in attendance, while ACT recorded a y-o-y decline in revenue despite a slight increase in attendance. WA, SA and NT recorded y-o-y growth in both revenue and attendance.</p>
          <p>In 2025, NT recorded the highest y-o-y growth in revenue (45.7%) and third-highest y-o-y growth in attendance (4.2%). However, its impact was limited, as NT contributed the least to the Contemporary Music category in both revenue and attendance.</p>
          <p>In 2025, SA recorded the second-highest y-o-y growth in revenue (35.3%) and highest y-o-y growth in attendance (15.4%), while WA recorded the third-highest y-o-y growth in revenue (31.4%) and second-highest y-o-y growth in attendance (11.9%). The growth in SA and WA was driven by performances by major artists such as AC/DC, Metallica, Katy Perry and Drake.</p>
          <p>The annual variability of this category strongly reflects the number of high-profile international artists that tour in any given year, particularly the number of stadium tours that attract larger audiences.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.<br>Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
        </div>
      </div>
    </figure>

    <div class="row clearfix">
      <h2 id="download-btn">Download the Report</h2>
      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/CONTEMPORARY MUSIC  Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          Contemporary Music Infographic Report 2025 (PDF)
        </a>
      </div>
    </div>

    <div class="fullbg">
      <p class="caption">Photo: <em>AC-DC</em>, TEG, Photo Credit: Brett Costello</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: [2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(3) + 'b'
            } else {
              revy = '$' + rev.y + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y.toFixed(3) + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          backgroundColor: '#FFFFFF'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [195.059, 287.201, 450.856, 503.24, 389.161, 460.443, 659.102, 539.274, 482.181, 628.13, 604.963, 477.905, 440.084, 826.05, 993.736, 835.545, 309.203, 144.938, 705.954, 1486.395, 1810.928, 1794.208],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [2.738, 3.924, 5.296, 5.976, 4.331, 4.683, 7.028, 5.94, 5.484, 6.266, 6.386, 5.555, 5.659, 8.465, 9.608, 8.290, 2.872, 2.732, 8.7, 12.006, 14.078, 13.745],
          color: '#d14967'
        }]
      },
      activeYear: 2025,
      stateBreakdowns: [
        {
          year: 2025,
          revenue: [
            ["NSW", 36.5],
            ["VIC", 33.3],
            ["QLD", 15.3],
            ["WA", 8.7],
            ["SA", 5.0],
            ["ACT", 0.5],
            ["TAS", 0.6],
            ["NT", 0.07],
          ],
          attendance: [
            ["NSW", 34.5],
            ["VIC", 32.2],
            ["QLD", 16.2],
            ["WA", 9.5],
            ["SA", 5.4],
            ["ACT", 0.8],
            ["TAS", 1.2],
            ["NT", 0.1],
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [
              {
                name: 'Attendance Share',
                data: stateBreakdown.attendance,
                size: '68%',
                innerSize: '40%',
                borderColor: 'none',
                borderWidth: 1,
                slicedOffset: 30,
                showInLegend: true,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -28
                }
              }, 
              {
                name: 'Revenue Share',
                data: stateBreakdown.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -32
                }
              }
            ],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("~@/assets/img/2025/23-Contemporary-Music-AC-DC_Photo_Venues-NSW_Brett-Costello_20251121_891.jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
